import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'workers',
  title: '打工人',
  routes: [
    { path: '/workers', name: 'workers', component: () => import('./WorkersView.vue'), meta: { tab: 'task', title: '打工人' } },
  ],
} satisfies FeatureModule
